import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_sales_order = async (sales_order) => {
  try {
    const data = {
      customer: sales_order?.customer,
      project: sales_order?.project,
      number: sales_order?.number,
      date: sales_order?.date,
      due_date: sales_order?.due_date,
      reference: sales_order?.reference,
      salesman: sales_order?.salesman,
      status: sales_order?.status,
      details: sales_order?.details,
      total: sales_order?.total,
      status: 1,
      id: sales_order?.id ? sales_order?.id : null,
      source: sales_order?.source ? sales_order?.source : null,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-sales-order`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_sales_order = async (sales_order) => {
  try {
    const data = {
      id: sales_order?.id,
      customer: sales_order?.customer,
      project: sales_order?.project,
      number: sales_order?.number,
      date: sales_order?.date,
      due_date: sales_order?.due_date,
      reference: sales_order?.reference,
      salesman: sales_order?.salesman,
      status: sales_order?.status,
      details: sales_order?.details,
      total: sales_order?.total,
      status: 1,
      source: sales_order?.source ? sales_order?.source : null,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-sales-order`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const delete_sales_order = async (sales_order) => {
  try {
    const data = {
      id: sales_order?.id,
      source: sales_order?.source ? sales_order?.source : null,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/delete-sales-order`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_sales_order = async (sales_order) => {
  try {
    const data = {};
    if (sales_order?.id) data.id = sales_order.id;
    else if (sales_order?.number) data.number = sales_order.number;
    else return { status: false, message: "sales_order ID or number is required" };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-sales-order`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_sales_order = async (sales_order) => {
  try {
    const data = {
      search: sales_order?.search,
      sort: sales_order?.sort,
      customer: sales_order?.customer,
      date: sales_order?.date,
      due_date: sales_order?.due_date,
      payment: sales_order?.payment,
      status: sales_order?.status,
      page: sales_order?.page,
      source: sales_order?.source,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-sales-order`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_sales_order_details = async (sales_order) => {
  try {
    const data = {
      search: sales_order?.search,
      status: sales_order?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-sales-order-details`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_sales_order_log = async (sales_order) => {
  try {
    const data = {
      search: sales_order?.search,
      sort: sales_order?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-sales-order-log`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_sales_order_logs = async (sales_order) => {
  try {
    const data = {
      search: sales_order?.search,
      sort: sales_order?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-sales-order-logs`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_sales_order,
  update_sales_order,
  delete_sales_order,
  get_sales_order,
  get_all_sales_order,
  get_all_sales_order_details,
  get_sales_order_log,
  get_all_sales_order_logs,
};
